// Prod Config
const baseApiUrl = "https://api.infra3d.com";

const ClientConfig = {
  conversionURL: `${baseApiUrl}/conversion/`,
  shibboClientId: `2n42lde6slrcibg5bj9bnf0d16`,
  shibboDomain: `https://auth-classic.infra3d.com`,
  loginURL: `${baseApiUrl}/login/`,
  logoutURL: window.location.origin + `/`,
  filegateURL: `${baseApiUrl}/filegate/`,
  framerURL: `${baseApiUrl}/framer/`,
  framegateURL: `${baseApiUrl}/framegate/`,
  geocoderURL: `${baseApiUrl}/geocoder/`,
  geofeatureserverURL: `${baseApiUrl}/geofeatureserver/`,
  linrefcodeURL: `${baseApiUrl}/linrefcode/`,
  pileURL: `${baseApiUrl}/pile/`,
  pilegateURL: `${baseApiUrl}/pilegate/`,
  stargateURL: `https://xxts716ql2.execute-api.eu-west-1.amazonaws.com/prod/`,
  lidargateURL: `${baseApiUrl}/lidargate/`,
  announcementApiURL: "https://cockpit.help.infra3d.com",
  riagateURL: `${baseApiUrl}/riagate/`,
  stage: `prod`,
  notMigrated: [
    `eu-west-1_SZ4EJaLQd`, // infra3dnextgen-classic
    `eu-west-1_iylZ5L4xo`, // infra3dnextgen-trial
  ],
};
export default ClientConfig;
